<template>
  <b-container v-if="influencer">
    <b-row>
      <b-col>
        <b-row>
          <b-col class="p-0 mt-3 mb-3">
            <h4 class="font-weight-bold">
              Recent Posts
              <b-form-checkbox
                v-if="influencer.vip_post_count > 0"
                v-model="vip_only"
                class="vip-switch"
                size="lg"
                switch
              />
            </h4>
            <p class="grey-light mb-1 mt-n2">
              <small v-if="list && list.length === 0"> No posts found </small>
              <small v-else>
                You can watch posts in the Vello app
                <span class="app-download" ref="badges">
                  <a :href="links.appStore">
                    <b-img
                      src="~@/assets/img/appstore.png"
                      height="15px"
                      class="app-icons cursor"
                      alt="appstore"
                    />
                  </a>
                  <a :href="links.playStore">
                    <b-img
                      src="~@/assets/img/playstore.png"
                      height="15px"
                      class="app-icons cursor"
                      alt="playstore"
                    />
                  </a>
                </span>
              </small>
            </p>
          </b-col>
        </b-row>

        <transition name="fade">
          <b-row v-if="list">
            <b-col
              cols="6"
              sm="4"
              md="3"
              lg="2"
              class="p-0 cursor"
              v-for="(feed, key) in list"
              :key="key"
              @click="openFeed(feed)"
            >
              <div
                :class="[
                  'pr-2 pb-2 radius-5 mr-2',
                  {
                    'is-locked': feed.is_vip_only && !influencer.has_vip_access,
                  },
                ]"
              >
                <div
                  class="feed-post radius-5"
                  :class="
                    feed.is_vip_only && !influencer.has_vip_access
                      ? `is-vip`
                      : ``
                  "
                  :style="showFeedImage(feed)"
                >
                  <div class="feed-description">
                    <div class="feed-tags" v-if="feed.tags">
                      <span v-for="tag in feed.tags" :key="tag">
                        {{ `#` + tag }}
                      </span>
                    </div>
                    <div
                      class="feed-caption"
                      :class="feed.conversation_id ? `is-response` : ``"
                    >
                      {{ feed.description }}
                    </div>
                  </div>
                </div>
              </div>
            </b-col>

            <b-col v-if="has_more" class="m-auto text-center pt-4" cols="12">
              <a href="javascript:;" @click="loadFeeds">
                <b-spinner v-if="loading" small class="mr-2" />
                <small>show more +</small>
              </a>
            </b-col>
          </b-row>
        </transition>
      </b-col>
    </b-row>

    <!-- MODAL FORM -->
    <play-video-modal :src="video_src" :poster="video_poster" />
  </b-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import PlayVideoModal from './PlayVideoModal'

export default {
  name: 'InfluencerFeeds',
  props: ['influencer'],
  components: {
    PlayVideoModal,
  },

  data() {
    return {
      loading: false,
      limit: 12,
      page: 1,
      video_src: null,
      video_poster: null,
      vip_only: false,
      filter: 'all',
    }
  },

  computed: {
    ...mapState({
      links: (state) => state.auth.links,
      list: (state) => state.feed.list,
      has_more: (state) => state.feed.has_more,
    }),

    params() {
      return {
        influencer_uid: this.influencer.influencer_uid,
        limit: this.limit,
        page: this.page,
        filter: this.filter,
      }
    },
  },

  methods: {
    ...mapActions({
      getList: 'feed/getList',
    }),
    ...mapMutations({
      clearList: 'feed/clearList',
    }),

    async loadFeeds() {
      this.loading = true

      await this.getList(this.params)

      this.loading = false
      this.page++
    },

    async playVideo(feed) {
      this.video_src = feed.video_url
      this.video_poster = feed.thumbnails.orig
      this.$bvModal.show(`playVideoFrame`)
    },

    openFeed(feed) {
      if (feed.is_vip_only && !this.influencer.has_vip_access) {
        this.$bvModal.show('vipAccessForm')
        return
      }

      this.playVideo(feed)
    },

    showFeedImage(feed) {
      if (feed.is_vip_only && !this.influencer.has_vip_access) {
        return (
          `background: linear-gradient(to bottom, rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)), url(` +
          feed.thumbnails.orig +
          `) center/cover;`
        )
      }
      return (
        `background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, .9)), url(` +
        feed.thumbnails.orig +
        `) center/cover;`
      )
    },

    filterFeeds() {
      this.filter = this.vip_only ? 'vip' : 'all'
      this.page = 1
      this.clearList()
      this.loadFeeds()
    },
  },

  mounted() {
    this.clearList()
    this.loadFeeds()
  },

  async destroyed() {
    this.clearList()
  },

  watch: {
    vip_only() {
      this.filterFeeds()
    },
  },
}
</script>

<style lang="scss" scoped>
.feed-post {
}
.feed-description {
  position: absolute;
  bottom: 8px;
  left: 0px;
  font-size: 0.6rem;
  width: calc(100% - 0.5rem);
  padding: 10px;
  letter-spacing: 0.2px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 95%;
  min-height: 50px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  .feed-tags {
    color: #ffb222;
    letter-spacing: 0;
  }

  .feed-caption {
    &.is-response {
      &:before {
        content: '';
        background: url('~@/assets/img/vello-name.png') right/contain no-repeat;
        height: 20px;
        width: 100%;
        position: absolute;
        bottom: 8px;
        right: 10px;
        opacity: 0.5;
      }
    }
  }
}

.is-vip .feed-description {
  color: #cccccc;
}
</style>
